var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryRiyal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9755_64551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5571 25.4619C15.111 26.4511 14.8161 27.5246 14.7031 28.6504L24.1439 26.6435C24.59 25.6545 24.8847 24.5808 24.9979 23.4551L15.5571 25.4619Z",
    fill: "#30322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.146 20.6314C24.5921 19.6424 24.887 18.5687 25 17.4429L17.6459 19.007V16.0003L24.1458 14.619C24.5919 13.63 24.8868 12.5563 24.9998 11.4306L17.6457 12.9933V2.18015C16.5189 2.81286 15.5181 3.65506 14.7046 4.64848V13.6187L11.7634 14.2438V0.709473C10.6366 1.34196 9.63581 2.18438 8.8223 3.1778V14.8687L2.24149 16.2671C1.79537 17.2561 1.50026 18.3298 1.38706 19.4556L8.8223 17.8755V21.6619L0.853986 23.3552C0.407867 24.3442 0.112975 25.4179 0 26.5437L8.3406 24.7712C9.01956 24.63 9.60312 24.2286 9.98252 23.6761L11.5121 21.4084V21.408C11.6709 21.1733 11.7634 20.8905 11.7634 20.5858V17.2503L14.7046 16.6252V22.6387L24.1458 20.6309L24.146 20.6314Z",
    fill: "#30322C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9755_64551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27.9411,
    fill: "white",
    transform: "translate(0 0.709473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryRiyal);
export default __webpack_public_path__ + "static/media/primaryRiyal.f4c01c2b628d60b506b06042caf7b571.svg";
export { ForwardRef as ReactComponent };